import React from "react";
import { SectionHeader } from "../../../common/WorkspaceChrome";

export function TeamActivityTab({ teamRows }) {
  return (
    <section className="panel">
      <SectionHeader
        eyebrow="Team Activity"
        title="Presence, workload, and blockers"
        text="Managers can scan attendance, capacity, blocked work, and team signals in one place."
      />
      <div className="team-activity-list">
        {teamRows.map((row) => (
          <article key={row.name}>
            <div>
              <strong>{row.name}</strong>
              <span>{row.detail}</span>
            </div>
            <em>{row.status}</em>
          </article>
        ))}
      </div>
    </section>
  );
}
